import React from 'react';
import { QuickLink } from './QuickLink';
import { QuickLinkType } from './QuickLink';
export interface QuickLinkProps {
  links: (QuickLinkType | null)[];
  children?: React.ReactNode;
}

export const QuickLinks = ({ links, children }: QuickLinkProps) => {
  return (
    <div className="grid grid-cols-1 gap-6 py-6 mt-6 lg:grid-cols-2 ">
      {links?.map((link, index) => {
        if (link)
          return (
            <QuickLink
              key={`${index}_${link.href}`}
              title={link.title}
              description={link.description}
              icon={link.icon}
              href={link.href}
              external={link.external}
              as={link.as}
            />
          );
      })}
      {children}
    </div>
  );
};
